/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './uploadBlob.defs.js'
export * as $defs from './uploadBlob.defs.js'
